<template>
  <v-container fluid class="down-top-padding">
    <base-breadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></base-breadcrumb>
    <base-card heading="Nova Avaliação">
      <form-exam-database action="add"></form-exam-database>
    </base-card>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    page: {
      title: 'Nova Avaliação'
    },
    breadcrumbs: [
      {
        text: 'Início',
        disabled: false,
        to: '/'
      },
      {
        text: 'Banco de Avaliações',
        disabled: false,
        to: '/examdatabase/list'
      },
      {
        text: 'Nova Avaliação',
        disabled: true
      }
    ]
  })
}
</script>
